import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { Provider } from 'react-redux';
// import Dashboard from './components/Dashboard';
import UsersList from './components/Users/UsersList';
import UsersProfile from './components/Users/UsersProfile';
import Landing from './components/Auth/Landing';
import DownloadApp from './components/DownloadApp';
import Auth from './components/Auth/Auth';
import ResetPass from './components/Auth/ResetPass';
import SetPassword from './components/Auth/SetPassword';
import AuthLayout from './components/Auth/AuthLayout';
import DashboardLayout from './components/DashboardLayout';
import store from './service/reducers/index';
import PrivateRoute from './components/PrivateRoute';
import AdminUsersList from './components/AdminUsers/AdminUsersList';
import AdminUsersProfile from './components/AdminUsers/AdminUsersProfile';
import CreateAdminUsers from './components/AdminUsers/CreateAdminUsers';
import ContractorsList from './components/Contractors/ContractorsList';
import ContractorProfile from './components/Contractors/ContractorProfile';
import Reports from './components/Reports/ReportsList';
import Transactions from './components/Transactions/TransactionsList';
import PageNotFound from './components/PageNotFound';
import GptPrompt from './components/General/GptPrompt';
import Setting from './components/General/Setting';
import { AuthProvider } from './contexts/AuthContext';
import axios from 'axios';

function App() {
  axios.defaults.baseURL = process.env.REACT_APP_BACKENDAPI;

  return (      
      <Provider store={store}>
        <AuthProvider>
        <Router>
              <Routes>
                <Route exact path="/sign-in" element={<AuthLayout><Auth /></AuthLayout>} />
                <Route path="/password-reset-request" element={<AuthLayout><ResetPass /></AuthLayout>} />
                <Route path="/set-password/:token" element={<AuthLayout><SetPassword /></AuthLayout>} />
                
                <Route path="/app-users" element={<PrivateRoute><DashboardLayout><UsersList/></DashboardLayout></PrivateRoute>} />
                <Route path="/app-users/:custId" element={<PrivateRoute><DashboardLayout><UsersProfile/></DashboardLayout></PrivateRoute>} />

                <Route path="/contractor-users" element={<PrivateRoute><DashboardLayout><ContractorsList/></DashboardLayout></PrivateRoute>} />
                <Route path="/contractor-users/:contractorId" element={<PrivateRoute><DashboardLayout><ContractorProfile/></DashboardLayout></PrivateRoute>} />


                <Route path="/reports" element={<PrivateRoute><DashboardLayout><Reports /></DashboardLayout></PrivateRoute>} />
                <Route path="/transactions" element={<PrivateRoute><DashboardLayout><Transactions /></DashboardLayout></PrivateRoute>} />
                
                <Route path="/admin-users" element={<PrivateRoute><DashboardLayout><AdminUsersList/></DashboardLayout></PrivateRoute>} />
                <Route path="/admin-users/:userId" element={<PrivateRoute><DashboardLayout><AdminUsersProfile/></DashboardLayout></PrivateRoute>} />
                <Route path="/admin-users/create" element={<PrivateRoute><DashboardLayout><CreateAdminUsers/></DashboardLayout></PrivateRoute>} />
                
                <Route path="/gpt-prompts" element={<PrivateRoute><DashboardLayout><GptPrompt/></DashboardLayout></PrivateRoute>} />
                <Route path="/settings" element={<PrivateRoute><DashboardLayout><Setting/></DashboardLayout></PrivateRoute>} />

                <Route path="/download-app" element={<DownloadApp />} />

                <Route exact path="/" element={<Landing />} />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
        </Router>
        </AuthProvider>
      </Provider>
  );
}

export default App;